const initState = {
	isFetching: false,
}

export default initState
